export const Enforcement = {
  Enabled: 'enabled',
  Disabled: 'disabled',
  Evaluate: 'evaluate',
} as const
export type Enforcement = (typeof Enforcement)[keyof typeof Enforcement]

export const DialogState = {
  closed: 'closed',
  selection: 'selection',
  deletion: 'deletion',
} as const
export type DialogState = (typeof DialogState)[keyof typeof DialogState]

export type SimpleRuleset = {
  title: string
  name: string
  enforcement: Enforcement
}

export interface ConvertToRulesetPreview {
  id: number
  targetedBranches: string
  rulesets: SimpleRuleset[]
  isEnabled?: boolean
  isFullyCovered?: boolean
  isDisabled?: boolean
}

export type EditablePreview = ConvertToRulesetPreview & {
  isEnabled: boolean
  isDisabled: boolean
}

export type ConvertToRulesetPreviewWithoutId = Omit<ConvertToRulesetPreview, 'id'>

export type Paths = {
  previewUrl: string
  createUrl: string
  validateRulesetNameUrl: string
}

export type PreviewPayload = Record<string, ConvertToRulesetPreviewWithoutId>

export interface IUpdatePreviews {
  togglePreview: ({id}: {id: number}) => void
  setRulesetName: ({
    id,
    rulesetIndex,
    newRulesetName,
  }: {
    id: number
    rulesetIndex: number
    newRulesetName: string
  }) => void
}
